"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInvestorFormTranslate = void 0;
exports.defaultInvestorFormTranslate = {
    email: 'Email',
    required: 'Required',
    nameSubmit: 'Submit',
    emailFormat: 'Invalid Email Format',
    phoneFormat: 'Invalid Phone Format',
    emailRequired: 'Email Required',
    firstnameRequired: 'Firstname Required',
    fullnameRequired: 'Name Required',
    lastnameRequired: 'Lastname Required',
    phoneRequired: 'Phone Required',
    phoneOremailRequired: 'Phone or Email Required',
    placeholderEmail: 'Email (eg. john.doe@okay.com)',
    placeholderFirstName: 'First Name (eg. John)',
    placeholderFullName: 'Name',
    placeholderLastName: 'Last Name (eg. Doe)',
    placeholderCompany: 'Company',
    placeholderPhone: 'Phone (eg. 2102 0888)',
    placeholderComment: 'Tell us your enquiry ...',
};
